import { Injectable, OnDestroy, DOCUMENT, inject } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * DomEventService (ApxEventService) is a singleton service which is responsible for providing
 * events to any component or directive through publically accessible observables.
 * This could be extended in future to capture a host of mouse or even keyboard events
 */
@Injectable({ providedIn: 'root' })
export class DomEventService implements OnDestroy {
    private readonly doc = inject<Document>(DOCUMENT);

    private readonly documentMousedownTarget: Subject<HTMLElement> = new Subject<HTMLElement>();
    private readonly mouseDownListener: (e: MouseEvent) => void;

    documentMousedownTarget$ = this.documentMousedownTarget.asObservable();

    constructor() {
        this.mouseDownListener = this.handleMousedown.bind(this);
        if (this.doc) {
            this.doc.addEventListener('mousedown', this.mouseDownListener);
        }
    }

    ngOnDestroy(): void {
        if (this.doc) {
            this.doc.removeEventListener('mousedown', this.mouseDownListener);
        }
    }

    private handleMousedown(e: MouseEvent): void {
        this.documentMousedownTarget.next(e.target as HTMLElement);
    }
}
